import OrganizationEditPage from './OrganizationEditPage';

export default OrganizationEditPage;
